<div
  class="link-block"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <div class="about-block-link">
    <p>{{ section.textContent.blocks[0].heading }}</p>
    <a
      class="link-to-more text-link"
      [routerLink]="section.textContent.blocks[0].headingLink"
      >{{ section.textContent.blocks[0].headingLinkDescription }}</a
    >
  </div>
</div>
